import { saveUserOperation } from '@/common/api/common';
import { deepCopy, isArray, isNotEmptyAny } from '@lhb/func';
import React from 'react';
// export const demoForTeslaModelId = 37;
export const demoForCarModelIds = [37, 48]; // 37 特斯拉 48 小米
export const CollectListContext = React.createContext<any>(null);
// 新视角模式-选址、管理视角（1114）
export enum TopViewEnum {
  siteView,
  manageView
}

// 缩小到5切换到国视角、缩小到8切换到省视角
export const countryZoom = 5;
export const provinceZoom = 8;
export enum levelEnum {
  country = 1, // 全国视角
  province = 2, // 省视角
  city = 3, // 城市视角
  site = 4, // 选址视角
}
export interface MapView {
  level: levelEnum | '';
  provinceId?: number;
  cityId?: number;
  districtIds?: number[];
}
export const siteselectionmapbOperation = 'siteselectionmapbOperation';

// 退出记录-ts类型
export interface LastOperation {
  isLoading:boolean;// 是否请求中
  isChooseView?:boolean;// 是否操作过选择视角
  curModelConfigId?: number; // 选择的模型
  level?: levelEnum; // 视角层级
  filialeOpen?: boolean; // 分公司开关
  provinceId?: number;
  cityId?: number;
  // countryRecord:countryRecordI;// 全国视角
  // provinceRecord:provinceRecordI;// 省视角
  // cityRecord:cityRecordI;// 市视角
  siteRecord?: siteRecordI; // 选址视角
}
// // 全国视角
// export interface countryRecordI{
//   filialeOpen:boolean// 分公司开关
// }
// 省视角
// export interface provinceRecordI{
//   provinceId:number
// }
// export interface cityRecordI{
//   cityId:number;
// }
export interface siteRecordI {
  // cityId:number;
  famousBrandListR: number[]; // 知名品牌
  curBrandListR: number[]; // 本品牌
  competitorListR: number[]; // 竞品品牌
  collectPointListR: number[]; // 收藏的开店区域勾选（左侧筛选项）
  isOpenSubwayR: boolean; // 地铁线路
  communityR:string[];// 小区选中项
}

/**
 * 品牌前六颜色范围
 */
export const BrandTop6ColorMap = {
  0: '#1E98FE',
  1: '#B8E7FF',
  2: '#FFD53A',
  3: '#21E5C6',
  4: '#A487F9',
  5: '#FFB9E0',
};

// 区以下聚合的临界条件
export const CLUSTER_CRITICAL_COUNT = 500;

// // 左下地图工具箱
// export const mapToolBoxImg = [
//   `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_network_putong.png`,
//   `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_network_weixing.png`,
//   `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_network_renkoureli.png`,
//   `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_network_canyinreli.png`,
// ];

export const rankIcon = [
  { url: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/pointone.png` },
  { url: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/pointtwo.png` },
  { url: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/pointthree.png` },
  { url: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/marker.png` },
];
export const selectRankIcon = [
  { url: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/selectone.png` },
  { url: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/selecttwo.png` },
  { url: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/selectthree.png` },
  { url: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/selectmarker.png` },
];
export const newCreateIcon = `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/siteSelection_map_ic.png`;
// export enum mapToolEnum {
//   normal = 'normal',
//   satellite = 'satellite',
//   population = 'population',
//   food = 'food',
// }

export const leftListSelectionDOM = 'leftListSelectionDOM';

export const sortRuleAliasOptions = [
  { id: 1, name: '市场评分排序', key: 'marketScore' },
  { id: 2, name: '商场客流排序', key: 'mallPassFlow' },
  { id: 3, name: '餐饮门店排序', key: 'foodStores' },
  { id: 4, name: '餐饮老店排序', key: 'oldCateringRate' },
  { id: 5, name: '500米人口排序', key: 'population' },
  { id: 6, name: '3km人口排序', key: 'population3km' },
  { id: 7, name: '商场面积', key: 'polygonArea' },
  { id: 8, name: '商户数', key: 'openStores' },
  { id: 9, name: '建成年份', key: 'mallOpenYears' },
  { id: 10, name: '预测营业额', key: 'salesAmountPredict' },
];

export enum tabsKey {
  energy = 'energy',
  all = 'all',
}
// 图层设置-竞品品牌
export const carBrandRadio = [
  { label: '所有品牌', key: tabsKey.all },
  { label: '能源类型', key: tabsKey.energy },
];

// 类名
export const mapCon = 'mapCon';
export const addBusiness = 'addBusinessBtn';
export const networkMapContainer = 'networkMapContainer';
export const topCon = 'topCon';
export const isDrawAreaButNoFormCon = 'isDrawAreaButNoFormCon';

export enum businessType {
  recommend = 'recommendArea',
  new = 'createArea',
}

export enum leftTab {
  condition = '条件筛选',
  layer = '图层设置',
}

export enum firstLevelCategoryIdEnum {
  businessCategory = 1, // 商业区
  communityCategory, // 社区型
  cultureEducationCategory, // 文教型
  transportationJunctionCategory, // 交通枢纽型
  workCategory, // 办公型
  scenicAreaCategory, // 景区型
  recombinationCategory, // 复合型
  streetShopCategory, // 街铺
  healthCareCategory, // 医疗保健 9
  carTradeMartCategory, // 汽车城 10
}

// 之前前端按照行业code决定一级行业名称，现在让接口直接返回行业名称了，下面的枚举暂时没用
export enum industryCodeEnum {
  /**
   * 中餐厅
   */
  chineseRestaurant = 1,
  /**
   * 外国餐厅
   */
  foreignRestaurant = 2,
  /**
   * 小吃快餐
   */
  snack = 3,
  /**
   * 咖啡
   */
  coffee = 4,
  /**
   * 奶茶饮品
   */
  milkTea = 5,
  /**
   * 面包甜品
   */
  bread = 6,

  /**
   * 汽车
   */
  carSale = 7,

  /**
   * 服饰鞋包
   */
  clothing = 8,
  /**
   * 超市便利
   */
  supermarket = 9,

  /**
   * 个护美妆
   */
  beauty = 10,
  /**
   * 医药保健
   */
  medicine = 11,

  /**
   * 汽车维修
   */
  carRepair = 12,
}

export const curModelConfigId = 'curModelConfigId';

/**
 * @description 根据城市id寻找对应的城市信息
 * @param provincesCities store中的provincesCities数据
 * @param cityId 当前城市id
 * @returns 城市信息（附带所在省份部分数据）
 */
export const findCurCItyInfo = (provincesCities, cityId) => {
  let city;
  provincesCities?.forEach((province) => {
    province?.children?.forEach((item) => {
      if (item.id === cityId) {
        city = {
          ...item,
          provinceName: province?.name,
          provinceId: province?.id,
          pinyin: province?.pinyin,
        };
      }
    });
  });
  return city;
};

// 缩放级别到17时，显示可视区域内所有的开店区域名称
export const showViewAreaNameZoom = 17;

/**
 * 获取最大值
 */
export const getMaxNum = (result) => {
  return result.reduce((acc, cur) => {
    if (acc < cur.count) {
      acc = cur.count;
    }
    return acc;
  }, 0);
};

/**
 * 获取颜色等级范围
 * @param maxNum
 * @returns
 */
export const getColorLevelRange = (maxNum) => {
  const range = [0.8, 0.6, 0.4, 0.2, 0];
  const res: any = [];
  range.reduce((acc, cur, index) => {
    if (acc === 1) return 1;
    let curMin = Math.floor(maxNum * cur);
    curMin = curMin === 0 ? 1 : curMin;
    const curMax = acc;
    // 插入范围对应当前的区间
    res.splice(index, 0, { curMin, curMax });
    if (maxNum === 1) {
      return [{ curMin: 1 }];
    }
    return curMin;
  }, maxNum);
  if (maxNum === 1) {
    return [{ curMin: 1 }];
  } else if (maxNum === 0) {
    return [];
  }
  return res;
};

/**
 * 根据数量获取颜色level
 * @param currentCount 当前数据
 * @param numRange 颜色范围 getColorLevelRange的结果集
 * @returns level 等级
 */
export const getColorLevelByCount = (currentCount, numRange) => {
  const data = deepCopy(numRange);
  let level = numRange.length + 1;
  if (!isNotEmptyAny(data) || !isArray(data)) return 6; // 如果空的，或者不是数组，则返回1
  if (!currentCount) return 6; // 如果count为空则返回层级6
  data?.map((item, index) => {
    if (currentCount === 1) { // 如果是1，额外处理
      level = index + 1;
    } else if (item.curMin < currentCount && currentCount <= item.curMax) {
      level = index + 1;
    }
  });

  return level;
};

/**
 * 记录操作
 */
export const recordOperation = (data) => {
  if (!data?.level || data.isLoading) return;
  saveUserOperation({
    operationMap: {
      [siteselectionmapbOperation]: data,
    },
  });
};

export interface district {
  code: string;
  id: number;
  lat: string | number;
  lng: string | number;
  name: string;
}
export interface mapInfo {
  city: any;
  district: any;
  level: number;
}
// 当前选中的行政区信息
export interface curSelectDistrictType {
  districtInfo: district[];
  cacheMapInfo: mapInfo | null;
}


export const isNumArray = (arr: number[]) => {
  if (!isArray(arr)) return false;
  return arr.reduce((acc, item) => {
    if (typeof item !== 'number') acc = false;
    return acc;
  }, true);
};
export const isXXArray = (arr: number[], type:string) => {
  if (!isArray(arr)) return false;
  return arr.reduce((acc, item) => {
    if (typeof item !== type) acc = false;
    return acc;
  }, true);
};

/**
 * !! 请勿轻易修改 top right bottom left
 * 根据当前位置的X，Y轴得到marker 的位置及offset
 * @param valueX 当前位置的X轴
 * @param valueY 当前位置的Y轴
 * @param mapClass 地图css
 * @param markerWidth marker的最大宽度
 * @param markerHeight marker的最大高度
 * @returns { anchor, offset }
 */
export const getMapMarkerAnchorOffsetByValueXY = (valueX, valueY, mapClass, markerWidth, markerHeight) => {
  const dom = document.querySelector(`.${mapClass}`);
  const offset = [40, -20];
  let topBottom = 'top';
  let leftRight = 'left';
  if (valueY < markerHeight) {
    topBottom = 'top';
    offset[1] = -20;
  } else if ((dom?.clientHeight || 0) - valueY < markerHeight) {
    topBottom = 'bottom';
    offset[1] = 10;
  }
  if (valueX < markerWidth) {
    leftRight = 'left';
    offset[0] = 40;
  } else if ((dom?.clientWidth || 0) - valueX < markerWidth) {
    leftRight = 'right';
    offset[0] = -40;
  }
  return {
    anchor: `${topBottom}-${leftRight}`,
    offset,
  };
};

// 围栏级别
export const polygonZoom = (modelId) => demoForCarModelIds.includes(modelId) ? [10, 20] : [13, 20];

// api:plan/selection
export const firstLevelCategory = [
  {
    'id': 1,
    'relationId': null,
    'name': '商业区',
    'displayName': null,
    'child': [
      {
        'id': 1,
        'relationId': null,
        'name': '商业体',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      },
      {
        'id': 2,
        'relationId': null,
        'name': '商业街',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      },
      {
        'id': 3,
        'relationId': null,
        'name': '商业区其他',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      }
    ],
    'color': '#7644E2',
    'hasViewColor': '#B49BEA',
    'icon': 'iconic_gouwu1'
  },
  {
    'id': 2,
    'relationId': null,
    'name': '社区型',
    'displayName': null,
    'child': [
      {
        'id': 4,
        'relationId': null,
        'name': '社区型',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      }
    ],
    'color': '#49C7FF',
    'hasViewColor': '#A1E0FC',
    'icon': 'iconic_shequ'
  },
  {
    'id': 3,
    'relationId': null,
    'name': '文教型',
    'displayName': null,
    'child': [
      {
        'id': 5,
        'relationId': null,
        'name': '高等院校',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      },
      {
        'id': 6,
        'relationId': null,
        'name': '中学',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      },
      {
        'id': 7,
        'relationId': null,
        'name': '小学',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      },
      {
        'id': 8,
        'relationId': null,
        'name': '文教其他',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      }
    ],
    'color': '#FF8456',
    'hasViewColor': '#F9BC88',
    'icon': 'iconic_wenjiao'
  },
  {
    'id': 4,
    'relationId': null,
    'name': '交通枢纽型',
    'displayName': null,
    'child': [
      {
        'id': 9,
        'relationId': null,
        'name': '机场',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      },
      {
        'id': 10,
        'relationId': null,
        'name': '火车站',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      },
      {
        'id': 11,
        'relationId': null,
        'name': '汽车站',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      },
      {
        'id': 12,
        'relationId': null,
        'name': '地铁站',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      },
      {
        'id': 17,
        'relationId': null,
        'name': '港口',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      }
    ],
    'color': '#FFC136',
    'hasViewColor': '#F7D892',
    'icon': 'iconic_jiaotongshuniu'
  },
  {
    'id': 5,
    'relationId': null,
    'name': '办公型',
    'displayName': null,
    'child': [
      {
        'id': 13,
        'relationId': null,
        'name': '写字楼',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      },
      {
        'id': 14,
        'relationId': null,
        'name': '办公园区',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      }
    ],
    'color': '#006AFF',
    'hasViewColor': '#7BB0FB',
    'icon': 'iconic_bangong'
  },
  {
    'id': 6,
    'relationId': null,
    'name': '景区型',
    'displayName': null,
    'child': [
      {
        'id': 15,
        'relationId': null,
        'name': '景区',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      }
    ],
    'color': '#0A9951',
    'hasViewColor': '#7FC7A3',
    'icon': 'iconic_jingqu'
  },
  {
    'id': 7,
    'relationId': null,
    'name': '复合型',
    'displayName': null,
    'child': [
      {
        'id': 16,
        'relationId': null,
        'name': '复合型',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      }
    ],
    'color': '#D259D9',
    'hasViewColor': '#E8ACEC',
    'icon': 'iconic_fuhe'
  },
  {
    'id': 8,
    'relationId': null,
    'name': '街铺',
    'displayName': null,
    'child': [
      {
        'id': 18,
        'relationId': null,
        'name': '街铺',
        'displayName': null,
        'child': null,
        'color': null,
        'hasViewColor': null,
        'icon': null
      }
    ],
    'color': '#F54593',
    'hasViewColor': '#F199C0',
    'icon': 'iconic_jiepu'
  }
];


export enum markTypeEnum {
  four = 4, // 四维模型
  five = 5, // 五维模型
  six = 6, // 六维评分
}

export const handleReplaceTargetStr = (str: string, isDemo = false) => {
  if (isDemo && str) {
    return str?.replace('开店区域', '商圈');
  }
  return str;
};

// 选址地图-管理视角下-统计维度列表
export const statisticDimensionList = [
  {
    key: 'marketCapacity',
    name: '市场容量',
  },
  {
    key: 'ownStore',
    name: '本品牌门店',
  }
];


/**
 * 规划统计枚举
 */
export enum planModelClusterEnum {
  /**
   * 省份
   */
  Country= '1',
   /**
   * 分公司
   */
  Company= '2',
}
export enum newPointStatusEnum{
  NO_REVIEW=0, // 无需审核
  IN_REVIEW =1, // 待审核-审核中
  APPROVE = 2, // 审核通过
  REJECT = 9// 审核拒绝
}

export enum CustomSortType {
  DISTANCE_SORT = 'lat_lng', // 距离排序
  INDUSTRY_SORT = 'storeOperationScore', // 行业评分
}


export const defaultSearchParams = {
  sort: 'desc',
  sortField: null, // 默认评分排序
};

export const getTargetDomId = {
  leftDrawer: 'siteSelectionMapbLeftDrawer',
  rightList: 'siteSelectionMapbRightList',
  youthMapDrawerWrapper: 'youthMapDrawerWrapper',
  youthMapLeftDrawerWrapperScrollCon: 'youthMapLeftDrawerWrapperScrollCon',
};
